import type { ApiClient, ApiService } from '@/lib/apiClient'
import { toApiError } from '@/lib/signalRApiService/utils'

interface Args {
  signalRConnectionId: string
  userId: string
  groupName: string
}

type Response = void

export type RemoveUserFromGroupApiService = ApiService<Args, Response>

const createRemoveUserFromGroupApiService =
  (apiClient: ApiClient): RemoveUserFromGroupApiService =>
  ({ signalRConnectionId, userId, groupName }) =>
    apiClient
      .post('removeFromGroup', {
        connectionId: signalRConnectionId,
        personId: userId,
        groupName,
      })
      .then(_ => undefined)
      .catch(error => Promise.reject(toApiError(error)))

export default createRemoveUserFromGroupApiService
